export class PackagesList {
  constructor() {
    this.initAvailableDates();
    this.initMobileCardToggles();
  }

  private initAvailableDates(): void {
    jQuery(document).on('click', '.package-available-dates-more', function (event: JQuery.Event): void {
      event.preventDefault();

      const button = jQuery(event.currentTarget);
      const container = button.closest('.package-available-dates');
      const url = container.data('load-more-url');
      const templateId = button.data('template-id');
      const skip = button.data('skip');

      button.prop('disabled', true);
      jQuery
        .get(url, { templateId: templateId, skip: skip })
        .done(function (html: string): void {
          const response = jQuery('<div>').append(html);
          const grid = container.find('.package-date-grid');

          button.remove();
          grid.append(response.find('.package-date-card'));
          container.append(response.find('.package-available-dates-more'));
        })
        .always(function (): void {
          button.prop('disabled', false);
        });
    });
  }

  private initMobileCardToggles(): void {
    jQuery(document).on('click', '.package-card-toggle', function (): void {
      let button = jQuery(this);
      let card = button.closest('.package-card');
      let details = card.find('.package-card-mobile-details');
      let isExpanded: boolean = button.attr('aria-expanded') === 'true';
      // Keep the package name in the accessible name so the toggles stay distinguishable
      // to screen-reader users on a list of cards.
      let packageName: string = button.data('package-name');
      let action: string = isExpanded ? 'Show' : 'Hide';

      button.attr('aria-expanded', (!isExpanded).toString());
      button.attr('aria-label', packageName ? `${action} details for ${packageName}` : `${action} details`);
      card.toggleClass('is-expanded', !isExpanded);
      details.prop('hidden', isExpanded);
    });
  }
}
